// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__10ikk","log":"ModalInventoryLogs_log__2k2y5","date":"ModalInventoryLogs_date__1m1WY","userName":"ModalInventoryLogs_userName__6n88o"};